import styled from "styled-components";
import { Flex } from "../../ui";
export const ListItemConceptList = styled(Flex) `
  flex-direction: column;
  box-sizing: border-box;
`;
